// App-wide constants
export const TOP_BAR_HEIGHT = 100;
export const DRAWER_WIDTH = 240;
export const CONTENT_OFFSET = 0;
